import { fetchWithAuth } from './fetchWithAuth';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 지부 목록 조회 — 로그인 전 호출, fetchWithAuth 대상 아님
export const fetchBranchList = async () => {
  const res = await fetch(`${BASE_URL}/branch`);
  return await res.json();
};

// 분회 목록 조회 — 로그인 전 호출, fetchWithAuth 대상 아님
export const fetchDivisionList = async (branch_code) => {
  const res = await fetch(`${BASE_URL}/branch/${branch_code}/divisions`);
  return await res.json();
};

// 분회 설정 수정 — 로그인 후 인증 필요, fetchWithAuth 적용
export const updateDivisionSettings = async (branch_code, division_code, phone, seal_img) => {
  return fetchWithAuth(`/branch/${branch_code}/divisions/${division_code}/settings`, {
    method: 'PUT',
    body  : JSON.stringify({ phone, seal_img }),
  });
};

// 분회 하위목록(병원) 조회 — 로그인 후 인증 필요, fetchWithAuth 적용
export const fetchDivisionSubList = async (branch_code, division_code) => {
  return fetchWithAuth(`/branch/${branch_code}/${division_code}/subs`);
};